import React from 'react';

// Define icons for different toast types
const ICONS = {
    success: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
    error: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>,
    info: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>,
};

// Define Tailwind CSS classes for different toast types
const TOAST_STYLES = {
    success: {
        bg: 'bg-green-100',
        border: 'border-green-500',
        text: 'text-green-800',
        iconColor: 'text-green-500'
    },
    error: {
        bg: 'bg-red-100',
        border: 'border-red-500',
        text: 'text-red-800',
        iconColor: 'text-red-500'
    },
    info: {
        bg: 'bg-blue-100',
        border: 'border-blue-500',
        text: 'text-blue-800',
        iconColor: 'text-blue-500'
    }
};

const Toast = ({ message, type }) => {
    // Select the appropriate style based on the 'type' prop, defaulting to 'info'
    const styles = TOAST_STYLES[type] || TOAST_STYLES.info;

    return (
        <div className={`w-full max-w-sm rounded-lg shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden border-l-4 ${styles.bg} ${styles.border}`}>
            <div className="p-4">
                <div className="flex items-start">
                    <div className={`flex-shrink-0 ${styles.iconColor}`}>
                        {ICONS[type] || ICONS.info}
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                        <p className={`text-sm font-medium ${styles.text}`}>
                            {message}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Toast;

